import { TimeTrackingState } from '../time-tracking-state';
import { WorkResponsibleType } from '../work/work-responsible/work-responsible-type-enum';
import { AutoClosingState } from './auto-closing-state';
import { MetadataType } from './metadata-type';
import { TaskInputType } from './task-input-type';
import { TaskTriggerSettingsDto } from './task-trigger-settings-dto';

export class TaskBaseDto {
  id: number;
  externalId: any; // TODO: change type to string after removing deprecated code
  activityId: number;
  activityName: string;
  activityExternalId: string;
  processId: number;
  processName: string;
  processExternalId: string;
  name: string;
  description: string;
  enabled: boolean;
  order: number;
  metadata: string;
  metadataType: MetadataType;
  enableEditInfo: boolean;
  enableEditTime: boolean;
  enableAdHoc: boolean;
  enableEditTimeEstimate: boolean;
  mandatoryForAdHoc: boolean;

  triggerSettings: TaskTriggerSettingsDto;

  hour: number;
  minute: number;
  information: string;
  hourEstimate: number;
  minuteEstimate: number;
  qaFor: number;

  inputType: TaskInputType;
  apiSourceExternalId?: number;
  eventSourceId?: number;

  defaultChecklistId: number;
  checklistIds: number[];

  hyperlinkId: number; //TODO: remove after release
  defaultHyperlinkIds: number[];
  hyperlinkIds: number[];

  workResponsibleId: number;
  workResponsibleType: WorkResponsibleType;
  allowedWorkResponsibleTypes: WorkResponsibleType[];
  compositeId: string; // points to "{workResponsibleId}-{workResponsibleType:number}"

  defaultTeamWorkResponsibleExternalId: string; // TODO: check if is still in use

  notificationMessage: string;

  enableTimeTracking: boolean;
  timeTrackingState: TimeTrackingState;
  enableLateWorkItemStatusPrompt: boolean;

  opiin: string;
  isQa: boolean;
  qaFormId?: number;

  enableAutoClosing: boolean;
  autoClosingState: AutoClosingState;
}
